<template>
    <div class="container">
        <router-link v-if="image" class="image" :to="linkTo">
            <img :src="image" :alt="name" />
        </router-link>
        <h2 class="name">
            {{ name }}
        </h2>
        <div class="description" v-html="description" />
        <router-link class="link" :aria-label="name" :to="linkTo">
            {{ $t("block_fixedprice_product_card.button") }}
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    computed: {
        linkTo() {
            return {
                name: "page_new_fixed_price_ticket",
                query: { productId: this.product.id }
            };
        },
        name() {
            return this.product.texts[this.$i18n.locale].name;
        },
        description() {
            return this.product.texts[this.$i18n.locale].description;
        },
        image() {
            if (!this.product.imageAvailable) {
                return null;
            }

            return (
                process.env.VUE_APP_API_URL +
                "v1/products/fixedpriceticket/info/image?id=" +
                this.product.id
            );
        }
    }
};
</script>

<style scoped lang="scss">
.container {
    background: white;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.12);
    box-sizing: border-box;
}

.image {
    margin: 0;
    display: block;
}

.image img {
    width: 100%;
    display: block;
}

.name {
    margin: 1rem;
    margin-bottom: 0.5rem;
    padding: 0;
    color: $color-darkest-grey;
    font-weight: 500;
    font-size: 1.5rem;
}

.description {
    margin: 1rem;
    line-height: 1.5rem;
    margin-top: 0.5rem;
    padding: 0;
    display: -webkit-box;
    -webkit-line-clamp: 3;

    /* autoprefixer: ignore next */
    -webkit-box-orient: vertical;
    max-height: calc(1.5rem * 3);
    overflow: hidden;
}

.description ::v-deep p {
    margin: 0px;
}

.link {
    font-weight: 600;
    text-decoration: none;
    float: right;
    margin: 1rem;
    margin-top: 0;
}
</style>
